import { render } from "./TabBreadcrumb.vue?vue&type=template&id=44e5148a&scoped=true"
import script from "./TabBreadcrumb.vue?vue&type=script&lang=js"
export * from "./TabBreadcrumb.vue?vue&type=script&lang=js"

import "./TabBreadcrumb.vue?vue&type=style&index=0&id=44e5148a&lang=scss&scoped=true"

import exportComponent from "/data/devops/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44e5148a"]])

export default __exports__